import { useRef } from 'react';

// Recharts v3 reports the hovered point index as a string, v2 as a number.
export function hoveredIndex(state, length) {
    if (!state || !state.isTooltipActive || state.activeTooltipIndex == null) return null;
    const idx = Number(state.activeTooltipIndex);
    return Number.isInteger(idx) && idx >= 0 && idx < length ? idx : null;
}

// Axis tick labels: up to 2 decimals, trailing zeros dropped, so 0.75 is not shown as 0.8.
export const formatTick = (v) => String(Number(Number(v).toFixed(2)));

// Hover overlay driven by the point Recharts itself resolves under the pointer, so the
// crosshair, the drawn line and the tooltip value always refer to the same sample.
// renderTip(idx) returns the tooltip HTML, or null to hide it for that point.
export function useChartHover({ length, renderTip, tipWidth = 130 }) {
    const wrapRef = useRef(null);
    const tipRef = useRef(null);
    const lineRef = useRef(null);

    const hide = () => {
        if (tipRef.current) tipRef.current.style.display = 'none';
        if (lineRef.current) lineRef.current.style.display = 'none';
    };

    const onMouseMove = (state) => {
        const wrap = wrapRef.current, tip = tipRef.current, ln = lineRef.current;
        const idx = hoveredIndex(state, length);
        const plot = wrap?.querySelector('.recharts-wrapper');
        const html = idx == null ? null : renderTip(idx);
        if (!wrap || !tip || !ln || !plot || html == null || state.activeCoordinate?.x == null) return hide();

        const wrapRect = wrap.getBoundingClientRect();
        const x = plot.getBoundingClientRect().left - wrapRect.left + state.activeCoordinate.x;

        ln.style.display = 'block';
        ln.style.left = x + 'px';

        tip.innerHTML = html;
        tip.style.display = 'block';
        let left = x + 10;
        if (left + tipWidth > wrapRect.width - 4) left = x - tipWidth - 10;
        tip.style.left = Math.max(0, left) + 'px';
        tip.style.top = '8px';
    };

    return { wrapRef, tipRef, lineRef, chartProps: { onMouseMove, onMouseLeave: hide } };
}
